module.exports = __webpack_public_path__ + "img/default-browse-vehicles-honda.058e48c2.png";